module.exports = __webpack_public_path__ + "img/aktuelles_adventsfenster2023.95c8fc10.jpg";